import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Country } from '@wdx/clmi/clmi-swagger-gen';
import { CountryNonpagedApiService } from '@wdx/clmi/clmi-swagger-gen/api-services';

@Injectable()
export class CountriesService {
    constructor(private countryNonpagedApiService: CountryNonpagedApiService) {}

    getCountries(): Observable<Country[]> {
        return this.countryNonpagedApiService.get();
    }
}
